import { AxiosResponse } from 'axios'
import { useCallback, useState } from 'react'

import { useAppErrorContext } from 'contexts/AppErrorContext'

interface Params {
  getData: () => Promise<AxiosResponse> // axios instance handler
  customErrorHandle?: boolean
  deps?: any[]
  fetchIf?: boolean
}

export const useDownloadFile = ({
  getData,
  customErrorHandle = false,
  deps = [],
  fetchIf = true,
}: Params): [() => void, boolean, any] => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<any>(null)
  const { setAppError } = useAppErrorContext()

  const downloadFileHandler = useCallback(async () => {
    if (fetchIf) {
      setLoading(true)
      try {
        const res = await getData()
        if (res?.status === 204) {
          setAppError('Statistic report is empty. Please, try to download it later.')
          return
        }
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = res.headers['content-disposition']?.split('filename=')[1]
        link.setAttribute('download', `${filename}`)
        document.body.appendChild(link)
        link.click()
      } catch (error: any) {
        if (!customErrorHandle) setAppError(error)
        else setError(error)
      } finally {
        setLoading(false)
      }
    }
  }, [...deps])

  return [downloadFileHandler, loading, error]
}
